import { ApiRequestConfigType } from 'requests/index.types';
import { AGENCY_USERS, CUSTOMER_USERS } from 'constants/endpoints';
import { METHOD_PUT } from 'requests';
import { AgencyUser, B2bCustomer } from 'types/graphql';

export const API_PUT_b2bUserProfile =
  (userId: string) =>
  (formValues: UserProfilePageForm): ApiRequestConfigType => {
    return {
      __typename: 'LegacyAPI',
      url: `${CUSTOMER_USERS}/${userId}`,
      method: METHOD_PUT,
      body: {
        user: {
          ...formValues,
        },
      },
    };
  };

export const API_PUT_agencyUserProfile =
  (userId: string) =>
  (formValues: UserProfilePageForm): ApiRequestConfigType => {
    return {
      __typename: 'LegacyAPI',
      url: `${AGENCY_USERS}/${userId}`,
      method: METHOD_PUT,
      body: {
        agency_user: {
          ...formValues,
        },
      },
    };
  };

export interface UserProfilePageForm {
  first_name: B2bCustomer['firstName'] | AgencyUser['firstName'];
  last_name: B2bCustomer['lastName'] | AgencyUser['lastName'];
  phone: string | undefined;
  email: B2bCustomer['email'] | AgencyUser['email'];
  locale: B2bCustomer['locale'] | AgencyUser['locale'];
}
